import { render } from "./ReteRicambiPassReset.vue?vue&type=template&id=10aaa9b0&scoped=true"
import script from "./ReteRicambiPassReset.vue?vue&type=script&lang=js"
export * from "./ReteRicambiPassReset.vue?vue&type=script&lang=js"

import "./ReteRicambiPassReset.vue?vue&type=style&index=0&id=10aaa9b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10aaa9b0"]])

export default __exports__